import { render } from "./DeleteSelectedItemsDialog.vue?vue&type=template&id=2f463790"
import script from "./DeleteSelectedItemsDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSelectedItemsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__